import { render, staticRenderFns } from "./PerformanceReportData.vue?vue&type=template&id=22e9380c&scoped=true"
import script from "./PerformanceReportData.vue?vue&type=script&lang=js"
export * from "./PerformanceReportData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e9380c",
  null
  
)

export default component.exports